var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("pdf-preview", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.inPreview,
            expression: "inPreview"
          }
        ],
        attrs: {
          inPreview: _vm.inPreview,
          generatingPreview: _vm.generatingPreview,
          saving: _vm.saving,
          pdfUrl: _vm.pdfUrl,
          backToForm: _vm.backToForm,
          save: _vm.save
        }
      }),
      _c(
        "form",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.inPreview,
              expression: "!inPreview"
            }
          ],
          attrs: { "data-vv-scope": "custom-document", autocomplete: "off" },
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c("h2", { staticClass: "mb-10" }, [_vm._v("Decreto Alcaldicio")]),
          _c("h4", { attrs: { id: "seccion-identificacion" } }, [
            _vm._v("Identificación")
          ]),
          _c(
            "div",
            {
              staticClass: "row",
              attrs: {
                role: "group",
                "aria-labelledby": "seccion-identificacion"
              }
            },
            [
              _c(
                "div",
                { staticClass: "col-md-6 col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Empresa", "label-for": "empresa" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "empresa",
                          name: "empresa",
                          "aria-label": "Empresa, campo de solo lectura",
                          readonly: "",
                          disabled: ""
                        },
                        model: {
                          value: _vm.empresa.razonSocial,
                          callback: function($$v) {
                            _vm.$set(_vm.empresa, "razonSocial", $$v)
                          },
                          expression: "empresa.razonSocial"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-6 col-12" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Comuna", "label-for": "comuna" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "comuna",
                          name: "comuna",
                          "aria-label": "Comuna Machalí, campo de solo lectura",
                          disabled: ""
                        },
                        model: {
                          value: _vm.formData.comuna,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "comuna", $$v)
                          },
                          expression: "formData.comuna"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c("vs-divider"),
          _c("h4", { attrs: { id: "seccion-cuerpo" } }, [
            _vm._v("Cuerpo del Decreto")
          ]),
          _c(
            "div",
            {
              staticClass: "row",
              attrs: { role: "group", "aria-labelledby": "seccion-cuerpo" }
            },
            [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("h5", { staticClass: "mb-2" }, [_vm._v("Vistos *")]),
                  _c("EditorText", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      name: "vistos",
                      "data-vv-as": "vistos",
                      danger: _vm.errors.has("custom-document.vistos"),
                      "danger-text": _vm.errors.first("custom-document.vistos"),
                      "max-length": 100000,
                      "toolbar-items": {
                        items: [
                          "undo",
                          "redo",
                          "|",
                          "heading",
                          "|",
                          "bold",
                          "italic",
                          "|",
                          "insertTable",
                          "|",
                          "numberedList",
                          "bulletedList"
                        ]
                      },
                      "with-counter": "",
                      "aria-label":
                        "Campo de texto enriquecido para Vistos, campo requerido",
                      "aria-required": "true",
                      "aria-invalid": _vm.errors.has("custom-document.vistos")
                        ? "true"
                        : "false"
                    },
                    model: {
                      value: _vm.formData.vistos,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "vistos", $$v)
                      },
                      expression: "formData.vistos"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12 mt-3" },
                [
                  _c("h5", { staticClass: "mb-2" }, [_vm._v("Considerando *")]),
                  _c("EditorText", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      name: "considerando",
                      "data-vv-as": "considerando",
                      danger: _vm.errors.has("custom-document.considerando"),
                      "danger-text": _vm.errors.first(
                        "custom-document.considerando"
                      ),
                      "max-length": 100000,
                      "toolbar-items": {
                        items: [
                          "undo",
                          "redo",
                          "|",
                          "heading",
                          "|",
                          "bold",
                          "italic",
                          "|",
                          "insertTable",
                          "|",
                          "numberedList",
                          "bulletedList"
                        ]
                      },
                      "with-counter": "",
                      "aria-label":
                        "Campo de texto enriquecido para Considerando, campo requerido",
                      "aria-required": "true",
                      "aria-invalid": _vm.errors.has(
                        "custom-document.considerando"
                      )
                        ? "true"
                        : "false"
                    },
                    model: {
                      value: _vm.formData.considerando,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "considerando", $$v)
                      },
                      expression: "formData.considerando"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12 mt-3" },
                [
                  _c("h5", { staticClass: "mb-2" }, [_vm._v("Decreto *")]),
                  _c("EditorText", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      name: "decreto",
                      "data-vv-as": "decreto",
                      danger: _vm.errors.has("custom-document.decreto"),
                      "danger-text": _vm.errors.first(
                        "custom-document.decreto"
                      ),
                      "max-length": 100000,
                      "toolbar-items": {
                        items: [
                          "undo",
                          "redo",
                          "|",
                          "heading",
                          "|",
                          "bold",
                          "italic",
                          "|",
                          "insertTable",
                          "|",
                          "numberedList",
                          "bulletedList"
                        ]
                      },
                      "with-counter": "",
                      "aria-label":
                        "Campo de texto enriquecido para Decreto, campo requerido",
                      "aria-required": "true",
                      "aria-invalid": _vm.errors.has("custom-document.decreto")
                        ? "true"
                        : "false"
                    },
                    model: {
                      value: _vm.formData.decreto,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "decreto", $$v)
                      },
                      expression: "formData.decreto"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c("vs-divider"),
          _c("h4", { attrs: { id: "seccion-visadores" } }, [
            _vm._v("Visadores")
          ]),
          _c(
            "div",
            {
              staticClass: "row",
              attrs: { role: "group", "aria-labelledby": "seccion-visadores" }
            },
            [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("ListUser", {
                    attrs: {
                      label: "Visadores del proceso *",
                      placeholder: "Selecciona el/los visadores",
                      name: "visadores",
                      "data-vv-as": "visadores",
                      "is-multiple": true,
                      autocomplete: true,
                      danger: _vm.visatorsError !== "",
                      "danger-text": _vm.visatorsError,
                      "aria-label":
                        "Selección múltiple de visadores con autocompletado, campo requerido, mínimo 1 visador",
                      "aria-required": "true",
                      "aria-invalid":
                        _vm.visatorsError !== "" ? "true" : "false"
                    },
                    on: { "full-user": _vm.handleVisadoresChange },
                    model: {
                      value: _vm.formData.visadores,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "visadores", $$v)
                      },
                      expression: "formData.visadores"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c("vs-divider"),
          _c("h4", { attrs: { id: "seccion-distribucion" } }, [
            _vm._v("Distribución")
          ]),
          _c(
            "div",
            {
              staticClass: "row",
              attrs: {
                role: "group",
                "aria-labelledby": "seccion-distribucion"
              }
            },
            [
              _vm._m(0),
              _c(
                "div",
                { staticClass: "col-md-6 col-12" },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: { label: "Direcciones", "label-for": "directions" }
                    },
                    [
                      _c(
                        "v-select",
                        {
                          attrs: {
                            id: "directions",
                            name: "directions",
                            "data-cy": "directions",
                            options: _vm.directions,
                            multiple: "",
                            label: "label",
                            placeholder: "Selecciona la/s direccion/es",
                            loading: _vm.loadingDirecciones,
                            "aria-label":
                              "Selección múltiple de direcciones, campo opcional",
                            "aria-busy": _vm.loadingDirecciones
                              ? "true"
                              : "false"
                          },
                          on: { input: _vm.searchUnits },
                          model: {
                            value: _vm.formData.directions,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "directions", $$v)
                            },
                            expression: "formData.directions"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              attrs: { slot: "no-options" },
                              slot: "no-options"
                            },
                            [_vm._v("no hay direcciones")]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "d-inline-block",
                          attrs: {
                            disabled: !_vm.directions.length,
                            "data-cy": "select-all-directions"
                          },
                          on: {
                            change: function($event) {
                              return _vm.selectDirections(
                                _vm.selectAllDirections
                              )
                            }
                          },
                          model: {
                            value: _vm.selectAllDirections,
                            callback: function($$v) {
                              _vm.selectAllDirections = $$v
                            },
                            expression: "selectAllDirections"
                          }
                        },
                        [_vm._v(" Seleccionar todas ")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.formData.directions.length
                ? _c(
                    "div",
                    { staticClass: "col-md-6 col-12" },
                    [
                      _c(
                        "b-form-group",
                        { attrs: { label: "Unidad", "label-for": "units" } },
                        [
                          _c(
                            "v-select",
                            {
                              attrs: {
                                id: "units",
                                name: "units",
                                "data-cy": "units",
                                options: _vm.units,
                                multiple: "",
                                label: "label",
                                placeholder: "Selecciona la/s unidad/es",
                                loading: _vm.loadingDepartamentos,
                                "aria-label":
                                  "Selección múltiple de unidades, campo opcional",
                                "aria-busy": _vm.loadingDepartamentos
                                  ? "true"
                                  : "false"
                              },
                              model: {
                                value: _vm.formData.units,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "units", $$v)
                                },
                                expression: "formData.units"
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  attrs: { slot: "no-options" },
                                  slot: "no-options"
                                },
                                [_vm._v("no hay unidades")]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "mt-2" },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "d-inline-block",
                              attrs: {
                                disabled: !_vm.units.length,
                                "data-cy": "select-all-units"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.selectUnits(_vm.selectAllUnits)
                                }
                              },
                              model: {
                                value: _vm.selectAllUnits,
                                callback: function($$v) {
                                  _vm.selectAllUnits = $$v
                                },
                                expression: "selectAllUnits"
                              }
                            },
                            [_vm._v(" Seleccionar todas ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col-12 mt-4 mb-3" },
                [_c("vs-divider")],
                1
              ),
              _vm._m(1),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c("EditorText", {
                    ref: "externalDistribution",
                    attrs: {
                      name: "externalDistribution",
                      "data-cy": "externalDistribution",
                      "data-vv-as": "distribución externa",
                      "max-length": 100000,
                      "toolbar-items": {
                        items: [
                          "undo",
                          "redo",
                          "|",
                          "heading",
                          "|",
                          "bold",
                          "italic",
                          "|",
                          "insertTable",
                          "|",
                          "numberedList",
                          "bulletedList"
                        ]
                      },
                      "with-counter": "",
                      "aria-label":
                        "Campo de texto enriquecido para distribución externa, campo opcional"
                    },
                    model: {
                      value: _vm.formData.distribucionExterna,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "distribucionExterna", $$v)
                      },
                      expression: "formData.distribucionExterna"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c("vs-divider"),
          _c("h4", { attrs: { id: "seccion-adjuntos" } }, [
            _vm._v("Adjuntos (Opcional)")
          ]),
          _c(
            "div",
            {
              staticClass: "row",
              attrs: { role: "group", "aria-labelledby": "seccion-adjuntos" }
            },
            [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c(
                    "div",
                    { staticClass: "col-md-3 align-items-end" },
                    [
                      _c("UploadFile", {
                        attrs: {
                          permission: "*",
                          accept: "application/pdf, .doc, .docx, .xlsx, .ppt",
                          text: "Seleccionar documentos",
                          "upload-to": "ed",
                          "button-class": { "btn-block": true },
                          "container-class": "w-100"
                        },
                        on: {
                          input: function($event) {
                            return _vm.addOthersFile()
                          }
                        },
                        model: {
                          value: _vm.fileOthers,
                          callback: function($$v) {
                            _vm.fileOthers = $$v
                          },
                          expression: "fileOthers"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "row align-items-center mt-1" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-md-3 align-items-end" },
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "has-permission",
                                rawName: "v-has-permission",
                                value: "ED060",
                                expression: "'ED060'"
                              },
                              {
                                name: "b-modal",
                                rawName: "v-b-modal",
                                value: "add-file-repository",
                                expression: "'add-file-repository'"
                              }
                            ],
                            staticClass: "btn-icon mt-1",
                            attrs: {
                              variant: "secondary",
                              "data-cy": "from-repository"
                            }
                          },
                          [
                            _c("feather-icon", {
                              attrs: { icon: "ServerIcon" }
                            }),
                            _vm._v(" Desde el repositorio ")
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._l(_vm.formData.attachments, function(file) {
                      return _c("div", { key: file.id, staticClass: "col-2" }, [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex flex-column align-items-center"
                          },
                          [
                            _c("vs-icon", {
                              attrs: {
                                icon: "description",
                                size: "25px",
                                color: "primary"
                              }
                            }),
                            _c(
                              "b",
                              {
                                staticClass: "text-truncate w-100 text-center"
                              },
                              [_vm._v(_vm._s(file.name))]
                            ),
                            _c("vs-button", {
                              attrs: {
                                color: "danger",
                                type: "flat",
                                icon: "clear"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.removeOthersFile(file.id)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    })
                  ],
                  2
                ),
                !!_vm.error.messageOthers
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger vs-input--text-validation-span v-enter-to text-left"
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(" " + _vm._s(_vm.error.messageOthers) + " ")
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            ]
          ),
          _c("repository-selector", {
            attrs: {
              "modal-id": "add-file-repository",
              "add-file": _vm.addFileRepo,
              files: _vm.formData.attachments,
              "remove-file": _vm.removeOthersFile
            }
          }),
          _c(
            "div",
            {
              staticClass: "row justify-end",
              attrs: { role: "group", "aria-label": "Acciones del formulario" }
            },
            [
              _c(
                "vs-button",
                {
                  staticClass: "mt-5 mr-5",
                  attrs: {
                    "data-cy": "cancel",
                    color: "primary",
                    disabled: _vm.saving
                  },
                  on: {
                    click: function($event) {
                      return _vm.back()
                    }
                  }
                },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "vs-button",
                {
                  staticClass: "mt-5 mr-5",
                  attrs: {
                    "data-cy": "preview",
                    color: "warning",
                    disabled: _vm.saving
                  },
                  on: { click: _vm.preview }
                },
                [
                  _vm._v(" Previsualizar "),
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.saving,
                        expression: "saving"
                      }
                    ],
                    staticClass: "spinner-border spinner-border-sm text-primary"
                  })
                ]
              ),
              _c(
                "vs-button",
                {
                  staticClass: "mt-5 mr-5",
                  attrs: {
                    "data-cy": "save",
                    color: "success",
                    disabled: _vm.saving
                  },
                  on: {
                    click: function($event) {
                      return _vm.save()
                    }
                  }
                },
                [
                  _vm._v(" Crear "),
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.saving,
                        expression: "saving"
                      }
                    ],
                    staticClass: "spinner-border spinner-border-sm text-primary"
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h5", { staticClass: "mb-3 mt-2" }, [_vm._v("Distribución Interna")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h5", { staticClass: "mb-3" }, [_vm._v("Distribución Externa")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }